import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementMeeting } from '../models/get-engagement-conference';

export const FetchEngagementConferences = createAsyncThunk(
    'engagementMeetings/fetch',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        let response: any;
        try {
            response = await axios.get(
                `/api/Marketplace/Engagements/${engagementId}/EngagementMeetings`
            );
        } catch (error) {
            response = error;
        }

        if (response?.status === 200) {
            return response.data as EngagementMeeting[];
        }

        // The shared axios instance resolves failed requests with the error
        // object itself (its status lives on error.response), so failures can
        // land here either way. A 403 means the user has no access to the
        // engagement's meetings — reject quietly instead of alarming the user.
        const failureStatus = response?.response?.status ?? response?.status;
        if (failureStatus !== 403) {
            createNotification(
                'An error occurred while fetching engagement meetings.',
                'error'
            );
        }
        throw new Error('Failed to fetch engagement meetings');
    }
);
